import React, { useState } from 'react';
import { useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';
import { Button } from '@common/components';
import { PERFORM_EXTENSION_OFFER_ACTION_MUTATION } from '@working-experience/graphql';

export function ExtensionOfferActionApprove({
  extensionOfferId,
}: {
  extensionOfferId: string;
}) {
  const [loading, setLoading] = useState(false);

  const [performAction] = useMutation(PERFORM_EXTENSION_OFFER_ACTION_MUTATION, {
    onCompleted() {
      createMessage('success', 'Extension Offer has been sent to supplier.');
    },
    onError: () => {
      setLoading(false);
      createMessage(
        'error',
        'Extension Offer could not be sent to supplier. Please try again or contact your hiring partner.'
      );
    },
  });

  const onClick = () => {
    setLoading(true);
    performAction({
      variables: {
        extensionOfferId: extensionOfferId,
        input: {
          action: 'approve',
        },
      },
    });
  };

  return (
    <Button kind="primary" loading={loading} onClick={onClick}>
      Approve
    </Button>
  );
}
